import { postMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const LOGIN_USERS_REQUEST = 'LOGIN_USERS_REQUEST';
export const LOGIN_USERS_SUCCESS = 'LOGIN_USERS_SUCCESS';
export const LOGIN_USERS_FAILURE = 'LOGIN_USERS_FAILURE';

// Action Creators
export const loginUsersRequest = () => ({
  type: LOGIN_USERS_REQUEST,
});

export const loginUsersSuccess = (users) => ({
  type: LOGIN_USERS_SUCCESS,
  payload: users,
});

export const loginUsersFailure = (error) => ({
  type: LOGIN_USERS_FAILURE,
  payload: error,
});

// Thunk Function

export const loginUsers = (body, external) => {
  return async (dispatch) => {
    dispatch(loginUsersRequest());
    try {
      const response = await postMethod(url.login, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(loginUsersSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(loginUsersFailure('error'));
      }
    } catch (error) {
      dispatch(loginUsersFailure(error));
    }
  };
};
